import List from "./UserList"
import New from "./NewUser"

const exportObj = {
    List,
    New
}

export default exportObj